import { CPTCodeQuestionsLinkIds } from "@/encounters/constants/cpt-code";
import { QuestionnaireCodingFilter } from "@/intake-forms/components/QuestionnaireChoiceField/QuestionnaireCodingFilterContext";
import { isProcedureCodeOfferedOn, ServiceDateKey } from "@/shared/procedure-code-effective-dates";

/**
 * Coding filters for the procedures drawer: its code search offers only codes billable on the
 * service date, the same rule as the procedure picker, and says so when every match is hidden.
 * Without a service date no rule applies.
 *
 * @param serviceDate Service date as `yyyy-MM-dd` in the encounter's timezone
 */
export function getProcedureCodingFilters(
  serviceDate: ServiceDateKey | undefined,
): Record<string, QuestionnaireCodingFilter> {
  return {
    [CPTCodeQuestionsLinkIds.Code]: {
      filterOption: (coding) => isProcedureCodeOfferedOn(coding.code ?? "", serviceDate),
      filteredOutMessage: "The matching codes aren't billable on this encounter's service date.",
    },
  };
}
